import { movies, type Movie } from "@/mocks/movies";
import { news, type NewsItem } from "@/mocks/news";
import { specials, type Special } from "@/mocks/specials";

export const allMovies = movies;
export const allNews = news;
export const allSpecials = specials;

export const allRegions: string[] = Array.from(
  new Set(movies.map((m) => m.region)),
);

export const allYears: number[] = Array.from(
  new Set(movies.map((m) => m.year)),
).sort((a, b) => b - a);

export const allTypes: string[] = Array.from(
  new Set(movies.map((m) => m.type)),
);

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getNewsById(id: string): NewsItem | undefined {
  return news.find((n) => n.id === id);
}

export function getSpecialById(id: string): Special | undefined {
  return specials.find((s) => s.id === id);
}

export function getMoviesByIds(ids: string[]): Movie[] {
  return ids
    .map((id) => getMovieById(id))
    .filter((m): m is Movie => Boolean(m));
}

export function getSpecialsByIds(ids: string[]): Special[] {
  return ids
    .map((id) => getSpecialById(id))
    .filter((s): s is Special => Boolean(s));
}

export function getRelatedMovies(movie: Movie, count = 4): Movie[] {
  const others = movies.filter((m) => m.id !== movie.id);
  const sameSpecial = others.filter((m) =>
    m.specialIds.some((s) => movie.specialIds.includes(s)),
  );
  const sameType = others.filter((m) => m.type === movie.type);
  const pool = [...sameSpecial, ...sameType, ...others];
  const unique = Array.from(new Map(pool.map((m) => [m.id, m])).values());
  return unique.slice(0, count);
}

export function searchMovies(query: string): Movie[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return movies.filter((m) =>
    [m.title, m.synopsis, m.region, m.type, ...m.tags].some((field) =>
      field.toLowerCase().includes(q),
    ),
  );
}

export function searchNews(query: string): NewsItem[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return news.filter((n) =>
    [n.title, n.summary, ...n.content].some((field) =>
      field.toLowerCase().includes(q),
    ),
  );
}

export const hotSearches: string[] = [
  "治愈",
  "校园",
  "都市",
  "文艺",
  "重逢",
  "甜宠",
];